import { FC, useEffect } from "react"

let resolvePageHydrated: () => void = () => undefined

// Module scripts run after the HTML is parsed, so #root is there; a prerendered page carries its width on it.
const isHydrating = typeof document !== "undefined" && !!document.getElementById("root")?.dataset.prerenderWidth

/**
 * Resolves once React has taken over a prerendered page (src/index.tsx hydrates it); already resolved on a page drawn
 * in the browser from scratch. React hydrates the page itself (inside WebsiteLayout's Suspense) in a second,
 * low-priority pass; a synchronous update reaching it before then — an Apollo query's loading state is one — makes
 * React throw the prerendered page away and draw it again (error #421). Work that would cause one on startup waits.
 */
export const pageHydrated: Promise<void> = isHydrating
  ? new Promise(resolve => {
      resolvePageHydrated = resolve
      // Should the page never mount (an error), sign-in state must still load.
      setTimeout(resolve, 5000)
    })
  : Promise.resolve()

/** Rendered inside the page's Suspense boundary: its effect runs once the page has been hydrated. */
export const PageHydratedMark: FC = () => {
  useEffect(() => resolvePageHydrated(), [])
  return null
}
